import { useContext } from 'react';
import { Locale } from '@mindtickle/ui-shell-core/Intl';

const useLocale = () => {
  const { currentLanguage, changeLanguage } = useContext(Locale.Context);
  return {
    currentLanguage,
    changeLanguage,
  };
};

export default useLocale;
